import { render, staticRenderFns } from "./saleRecord.vue?vue&type=template&id=b8a1fc46&scoped=true&lang=pug"
import script from "./saleRecord.vue?vue&type=script&lang=js"
export * from "./saleRecord.vue?vue&type=script&lang=js"
import style0 from "./saleRecord.vue?vue&type=style&index=0&id=b8a1fc46&prod&lang=scss&scoped=true"
import style1 from "./saleRecord.vue?vue&type=style&index=1&id=b8a1fc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a1fc46",
  null
  
)

export default component.exports